import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50" data-testid="auth-loading">
        <div className="w-64">
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">Authenticating…</div>
          <div className="indus-bar" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
